import React from "react"
import { Link } from "gatsby"

import Layout from '../../components/layout'
import Seo from '../../components/seo'

import '../css/article.css'
//import images

import city from '../../images/sun-disappers/sun_city.png'
import dam from '../../images/sun-disappers/sun_dam.png'
import dyson from '../../images/sun-disappers/sun_dyson.png'
import frozen from '../../images/sun-disappers/sun_frozen.png'
import image from '../../images/sun-disappers/sun_image.png'
import satellite from '../../images/sun-disappers/sun_satellite.png'

import gif from '../../gifs/sun_gif.webp'
import robot from '../../images/robot.png'
import bat from '../../images/bat.png'

const IndexPage = () => {
 
  return  (
<Layout>
    <Seo 
    title="What if the sun gets disappeared- SUN FACTS|SKTUTS"
    description="Let us imagine the sun is stolen from solar system.Lets us see what will be the implications of it on planet earth and all other planets."
    keywords="sun facts,facts about sunflowers,sun facts for kids,sun bear facts,sunscreen facts,sun facts.com,sun facts nasa,sun nutrition facts shirt,sun conure facts,sun core facts,sunburn facts,facts on sun safety,facts about the sunlight zone,sundial facts,sun safety facts,ra sun god facts,facts about sunspots,sun amazing facts,sun gazing facts,sun corona facts,facts about sunglasses,sun spider facts,sun tzu facts,sundew facts,sun exposure facts,sun protection facts,sun nutrition facts shirt yellow,sun yat sen facts,sun damage facts,sunrise facts,sun facts sheet,sun bear interesting facts,sun facts for kindergarten,sun basic facts,sun planet facts,sun layers facts,sun facts and information,sun nutrition facts shirt zara,sun nutrition facts t shirt,sun valley facts,sunblock facts,sun safety facts australia,sun cancer facts,sun facts for 4th graders,sun facts for 2nd graders,sun care facts,sun nutrition facts,sunflower oil facts,sun facts video,sun tanning facts,sun god facts,capri sun health facts,sunsmart facts,mayan sun god facts,inti sun god facts,sun bear habitat facts,sun awareness facts,sun dangers facts,sun city facts,sun eclipse facts,sun earth facts,sun facts and pictures,sun facts about the sun,sun facts for elementary students,sun facts for 6th graders,sun facts wikipedia,sun facts ks2,sun god ra facts,sun facts worksheet,sun jellyfish facts,sun heat facts,sun quick facts,sun moon facts,sun temple facts,sun radiation facts,sunbed facts,sun yixian facts,arapaho sun dance facts,70 sun facts,facts of sun in hindi,earth sun moon facts ks2,facts on sun bears,facts of sun temple,facts sun earth moon,facts on sun conures,golden sun moth facts,facts sun maid raisins,midnight sun movie facts,kim sun woong facts,sun 10 facts,nutrition facts sun maid raisins,sun 5 facts,sun 3 facts,sun bear facts endangered,sun amazing facts in hindi,sun bear facts wikipedia,sun bear facts national geographic,sun belt facts,sun bears unique facts,sun chips health facts,sun cancer facts australia,sun conure habitat facts,sun chromosphere facts,sun cream facts uk,sun conure interesting facts,sun dance facts,sun dagger facts,sun earth moon facts wikipedia,sun dog facts,sun facts 15,sun easy facts,sun facts 5th grade,sun facts 2019,sun facts bbc,sun facts and latest information,sun facts color,sun facts bbc bitesize,sun facts energy,sun facts ducksters,sun facts for 10 year olds,sun facts facts,sun facts for 3rd graders,sun facts for 1st grade,sun facts for 8th graders,sun facts for 7th graders,sun facts for toddlers,sun facts for projects,sun facts from nasa,sun facts for year 5,sun facts gravity,sun facts grade 3,sun facts history,sun facts hindi,sun facts in spanish,sun facts in hindi,sun facts in telugu,sun facts in tamil,sun facts kiddle,sun facts interesting,sun facts nasa.gov,sun facts list,sun facts no one knows,sun facts national geographic,sun facts photosynthesis,sun facts pdf,sun facts powerpoint ks1,sun facts powerpoint,sun facts ppt ks2,sun facts ppt,sun facts printable,sun facts preschool,sun facts quiz,sun facts qld,sun facts song,sun facts solar system,sun facts temperature,sun facts summer,sun facts that will blow your mind,sun facts that are cool,sun facts usa,sun facts twinkl,sun facts year 1,sun facts website,sun facts.org,sun facts youtube,sun halo facts,sun god egypt facts,sun incredible facts,sun health facts,sun key facts,sun information facts,sun landscape facts,sun king facts,sun life financial facts 2017,sun life facts and figures,sun lit facts,sun life nutrition facts hawaiian bowl,sun mask facts,sun lotion facts,sun meaning facts,sun math facts,sun newspaper facts,sun moon lake facts,sun orchid facts,sun ning facts,sun ra facts,sun protection quick facts,sun related facts,sun rays facts,sun rotation facts,sun ring facts,sun safety facts qld,sun run facts,sun sign facts libra,sun safety facts uk,sun temple modhera facts,sun tan lotion facts,sun uv facts,sun unknown facts,sun valley idaho facts,sun uv rays facts,sun worship facts,sun weird facts,sun yang facts,sun wukong facts,sun's radiation zone facts,sun's convection zone facts,the sun educational facts,sundrop facts,useless sun facts,unusual sun facts,young sun facts,viking sun facts,25 sun facts,20 sun facts,50 sun facts,"
    />
    <header>
    <h1 className="header-h1">What if sun disappears</h1>

    <div className="header-banner">
        <img src={image} alt=" sun"/>
    </div>
   
    </header>
     
            <section className="content">
            <article>
            <h1>Sun Facts:What will happen if the sun get stolen by aliens</h1>
            <p>
            <img src={gif} alt="glowing gif of sun" />
            </p>
                           <h2>Intro about the sun</h2>
                           <p>
                               Let us imagine what would happen if the sun is disappeared for a second,for a minute ,for an hour, for a day,for a month or for a year.Let us see the fate of the earth after the sun is removed from the system and we will also see the implications on other planets.
                               In the last article we have discussed what would happen if the moon gets burst and  to read the article click right <a href="../moon-facts/what-will-happen-if-the-moon-bursts-and-disappered.html" target="_blank">here</a>. <br/>
                               Let us see its impact on planet earth and lets start our story.
                           </p>
                           
                           <h2>Alien invasion on sun</h2>
                           <p>
                               Let us suppose that aliens from a far and a much developed civilization came to our solar system to steal our sun using their dyson Spheres. <br/>
                               <div>
                                   <h3><a href="https://en.wikipedia.org/wiki/Dyson_sphere" target="_blank" rel="noopener noreferrer">Dyson sphere</a></h3> 
                                    <p>
                                   <img src={dyson} alt="Dyson ring concept that encloses the sun and steals it" /> <br/>
                                   Dyson sphere is a hypothetical concept in which the aliens come along with their large reflective mirrors and place it all around the star they want to capture.The mirrors are high powered and are alligned such that all the rays of the star is redirected to their own energy resource and extract all the energy and use it for their energy requirements. As the power of star decreases they take it away with them and use it for their purposes. 
                                    </p>
                                </div>
                                This is a completely fictional topic but let us dive deep into it and see what happens if the sun is disappeared.This is more or less like a horror story so stay calm and read the full <article className=""></article>

                           </p>
                           <h3>The sun is stolen</h3>
                           <p>
                               As soon as the sun is taken by the aliens all the planets including the earth loose all the gravitational power which they receive from the sun and they no more are attracted by the sun around which they used to revolve earlier.All the planets like jupiter,earth ,saturn ,uranus etc experience no gravitaional force now and they dont have any path to revolve around the sun.Now they wander in our solar system and are like floating giants and move here and there as there is no sun which keeps them in track and now they are free.
                                <br/>
                               In our earth its daytime and everything is normal and no one is aware that the sun is stolen.This is due to the reason that sun rays take about 8mins and 20secs to reach from the sun to earth.What sunrays we see now was emitted 8min and 20 secs before and we are seeing every activity of sun in a delay of this time interval.Like the sunrise we see is over and we are seeing a past of the sunrise as it was done 8min and 20 secs before it <br/>

                               Lets get back to our story and see the consequences under various time intervals.
                               <h3>After 8 mins and 20 secs</h3>
                               Everything in earth is normaland the sun looks fine .No one knows that the most important element of solar system is destroyed and is no more.Everything is fine until after 8 mins and 20 secs the whole sky is covered by black colour and the sun is nowhere to be seen.They realized that the sun is stolen.In just one second all the stars of the solar system are vsible to us as sun is not there.Its complete darkness here. <br/>The moon and other planets are not visible anymore as they dont ahve their own light and they reflect sunlight only.The most adverse affect of this will be on plants as they rely on sunlight to stay alive using a process called as photosynthesis.As there is no sunlight the plants are unable to produce oxygen to earth.
                               <h3>After 1 hour</h3>
                               Many people are not able to understand what had just happened.The places where there was day also converted to night.The other half of world where there was night also came to know about the situation that the other half also has darkness everywhere.
                             <br/>
                            The earth begins to cool drastically but due to the core of the earth which is so hot there is not much difference and everything seems in control.
                           </p>
                           <h3>After 24 Hours</h3>
                           <p>
                               Everyone is hoping for a sunrise and the government is also not able to do anything as it is not under thier control.The temperature is getting down drastically as our atmosphere's heat is all used up and no new source of heat is available.Now the temperature is as down as 8 degree celsius and the animals and plants are not able to survive in this drastic conditions and are begining to die.But the deep sea life is not so affected as sun was nothing for them and they relied on earth's hot core ,so everything is normal there.
                                <br/>
                               Some heat is still available in some places as the atmosphere retained some heat in those places.But this stored heat can only be there for 3-4 days.But now 

                           </p>
                           <h3>After 7 days</h3>
                           <p>
                               Still there is extreme dark and the temperature is about minus 20 degree celsius and is decreasing drastically.At zero degrees water becomes ice and now the temperature is in negative. Water is not available in the form of liquid and also TVs,radios and internet are not working as they are operated by satellites which gain their power through solar panels from the sun. 
                                <br/> <br/>
                               <img   src={satellite} alt="satellite which use their primary energy source as sunlight are now not working and are dead"/>
                                <br/> <br/>Scientists for some days used the high power battery equipped in the satellite but as the batteries went down it all stopped as the Scientists never thought sun would disappear and never thought of any other alternative.
                               <img   src={dam} alt="Dams producing electricity are now frozen and are not able to produce any power"/>

                               All the electricity is now gone as the dams which were used to produce electricity are now frozen and are not able to do anything.Still in some places electricity is there as they produce from other sources but that wont last long.Also mobile phone towers and landline are also not working because satellites are dead and no electricity available.The world connected by internet is now not working and people are dying to talk to their relatives who are far away. 
                                <br/>Almost all the plants and trees are dead as there is no sun available to help them perform their usual photosynthesis process and also the animals eating the those plants are staring to die.
                                <br/>
                               All the rich people in the world in these 7 days have built an underground basement for them to live and survive.Government also constructed some basements but they are not sufficient for all the population of the country.There is also a scarcity of food as crops cannot be grown in these conditions.Those peoples who had reserve foods survived for some days.Time doesn't make any sense now and whole 24 hrs is a night now.Darkness everywhere
                            </p>
                            <h3>After a month</h3>
                            <p>
                                Since there is no sun the earth does not rotate anymore and is now floating in space and has now reached some unknown destination in space.Temperature is going down and is now about -40 degrees and all the humans are almost dead.
                                <img   src={frozen} alt="In the extreme lower temperature all the water is frozen and the earth looks like this"/> <br/>
                                All the surface water is frozen and now the earth looks something like the above picture.The whole life is finished except for one place which is the deep sea which is heated by earth's core.All the surface plants and animals are dead and are covered by snow.Except for some tree of arctic region almost all vegetation is dead.
                                The air in the earth is much more polluted and also consists of much higher CO2 as there are no plants to filter the CO2 in atmosphere.
                                

                            </p>
                            <h3>After an year</h3>
                            <p>
                                All the places where life could be alive is dead now and the earth looks like a white snowball.
                                <img   src={city} alt="City after freezing of the earth."/>
                                The temperature went as down as -100 degrees and everything is under snow.Cities now look like the image above.

                            </p>
                            <h3>After 1000 years</h3>
                            <p>1000
                                years have passed and now the earth has became a perfect sphere and is fully covered by ice.The current position of earth is not known and it has travelled a lot of distance by floating and is currently in some unknown galaxy floating here and there.Also other planets like mercury,jupiter,uranus are also millions of kilomters away and are in some unknown places.Here all the planets are randomly hit by some asteroids and destroy it more.
                                 <br/>In the end the earth is hit by an high speed asteroid and is broken into small pieces and everything is finished even if this doesn't happen it can be swallowed by some black hole or remain in the space wandering.

                            </p>
                            <h3>Verdict</h3>
                            <p>But guys dont worry this is just a hypothesis and nothing such wll happen.Its just a fictional story.But from this we come to know that how important sun is to earth and other solar system.Life is possible with the help of sun only and that's why it is given a place of god in hindu mythology.</p>
            </article>
            <div className="other">
                <div className="content1">
                  <Link to="/isro-aditya-l1/aditya-l1-isro-mission-to-conquer-the-sun">
                     <h4>
                        ISRO's mission to conquer the sun    
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/area-51/the-mystery-of-area-51-revealed">
                     <h4>
                        The mystery of area 51 revealed
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>
                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/amazon.com/unique-products-available-on-amazon">
                     <h4>
                        Unique products available on amazon.in
                      <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>
                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/cicada-3301/the-unsolved-mystery-of-cicada-3301">
                     <h4>
                        The unsolved mystery of cicada 3301
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="create-a-blog/an-indepth-guide-on-how-to-make-a-blog">
                     <h4>
                        How to create a free blog
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/truecaller-truth/truecaller-business-model-and -truth-revealed">
                     <h4>
                         The truth of truecaller app
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/devil-sea/the-mystery-of-devil-sea">
                     <h4>
                        The unsolved mystery of devil sea
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/time-travel/the-mystery-of-time-travel-revealed">
                     <h4>
                         The time travel mystery revealed
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/earn-money-online/ultimate-guide-to-earn-money-in-2019">
                     <h4>
                         Simple steps to earn money online
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
           
            <div className="other">
                <div className="content1">
                  <Link to="/fast-charger/fast-charging-technologies-explained">
                     <h4>
                        The principle of fast charging in smartphones
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/flat-earth/the-reality-of-flat-earth-society-debunked">
                     <h4>
                         The reality of flat earth society
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/smartphone-buying/ultimate-guide-to-purchase-smartphone">
                     <h4>
                         Ultimate guide to purchase a new smartphone
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/global-warming/innovative-technology-to-stop-global-warming">
                     <h4>
                        Innovation In Technologies to stop global warming
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/gps-working/indepth-guide-on-how-gps-works">
                     <h4>
                         Indepth guide on the working of GPS
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/pyramids-mystery/aliens-involvement-in-construction-of-pyramids">
                     <h4>
                        The alien involvement in construction of pyramids
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            
            <div className="other">
                <div className="content1">
                  <Link to="/laptop-buying/ultimate-laptop-buying-guide">
                     <h4>
                         The ultimate laptop buying guide             
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/moon-facts/what-if-moon-disappears">
                     <h4>
                         What if the moon disappears
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 

                
         
</section> 
</Layout>
)}

export default IndexPage
